export const FETCH_USERS = 'src/ManageAccountStatus/FETCH_USERS';
export const FETCH_USERS_SUCCESS = 'src/ManageAccountStatus/FETCH_USERS_SUCCESS';
export const FETCH_USERS_FAILURE = 'src/ManageAccountStatus/FETCH_USERS_FAILURE';
export const DEACTIVATE_USER = 'src/ManageAccountStatus/DEACTIVATE_USER';
export const DEACTIVATE_USER_SUCCESS = 'src/ManageAccountStatus/DEACTIVATE_USER_SUCCESS';
export const DEACTIVATE_USER_FAILURE = 'src/ManageAccountStatus/DEACTIVATE_USER_FAILURE';
export const REACTIVATE_USER = 'src/ManageAccountStatus/REACTIVATE_USER';
export const REACTIVATE_USER_SUCCESS = 'src/ManageAccountStatus/REACTIVATE_USER_SUCCESS';
export const REACTIVATE_USER_FAILURE = 'src/ManageAccountStatus/REACTIVATE_USER_FAILURE';
